import React, { Component } from 'react';
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { NavLink, Route, Redirect, Switch } from 'react-router-dom'

import { PootsyTitle } from './DesignFunctions'

import AccountProfile from './AccountProfile'
import AccountAddresses from './AccountAddresses'
/* import AccountNotifications from './AccountNotifications' */
import AccountSecurity from './AccountSecurity'
import AccountPrivacy from './AccountPrivacy'

class Account extends Component {
	render() {
		let { t } = this.context
		let { match } = this.props
		return (
			<div className="Account">
				<div className="left">
					<PootsyTitle title={t("my_account")}/>
					<div className="nav">
						<NavLink to={match.url + "/profile"} isActive={isProfileLinkActive}>{t('profile')}</NavLink>
						<NavLink to={match.url + "/addresses"}>{t('addresses')}</NavLink>
						{/*<NavLink to={match.url + "/notifications"}>{t('notifications')}</NavLink>*/}
						<NavLink to={match.url + "/security"}>{t('security')}</NavLink>
						<NavLink to={match.url + "/privacy"}>{t('privacy')}</NavLink>
					</div>
				</div>
				<div className="right">
					<Switch>
						<Route exact path={match.url + "(|/profile)"} component={AccountProfile}/>
						<Route path={match.url + "/addresses"} component={AccountAddresses}/>
						{/*<Route path={match.url + "/notifications"} component={AccountNotifications}/>*/}
						<Route path={match.url + "/security"} component={AccountSecurity}/>
						<Route path={match.url + "/privacy"} component={AccountPrivacy}/>
						<Redirect to={match.url}/>
					</Switch>
				</div>
			</div>
		)
	}
}

const isProfileLinkActive = (match, location) => {
	if (location.pathname === '/account') {
		return true
	}
	else if (!match) {
		return false
	}

	return match.path === '/account/profile' || match.path === '/account'
}

Account.contextTypes = { t: PropTypes.func }
const mapStateToProps = state => ({
	user: state.dataReducer.currentUser
})
export default connect(mapStateToProps)(Account);



// WEBPACK FOOTER //
// ./src/components/Account.js